import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35b059ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = {
  class: "btns min-h-[60px]"
};
import { onUnmounted, ref, watch, onMounted, reactive } from 'vue';
export default {
  __name: 'EarTraining808',
  props: {
    items: {
      type: Object,
      default: () => ({})
    },
    reviewMode: {
      type: Boolean,
      default: false
    }
  },
  emits: ['answer'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    let timer;
    const answer = ref('N');
    watch(props, newVal => {
      init();
    });
    onUnmounted(() => {
      clearTimeout(timer);
    });
    const onChoosed = val => {
      clearTimeout(timer);
      emit('answer', val);
    };
    const init = () => {
      console.log(11111, props.items.questionIndex);
      answer.value = 'N';
      clearTimeout(timer);
      if (!window.AudioContext) {
        alert('当前浏览器不支持Web Audio API');
        return;
      }
      const frequencyLow = 196.00;
      const frequencyHigh = 1046.50;
      // 创建新的音频上下文接口
      const audioCtx = new AudioContext();
      const play = () => {
        // 当前频率
        const frequency = props.items.sound === 1 ? frequencyHigh : frequencyLow;

        // 创建一个OscillatorNode, 它表示一个周期性波形（振荡），基本上来说创造了一个音调
        var oscillator = audioCtx.createOscillator();
        // 创建一个GainNode,它可以控制音频的总音量
        var gainNode = audioCtx.createGain();
        // 把音量，音调和终节点进行关联
        oscillator.connect(gainNode);
        // audioCtx.destination返回AudioDestinationNode对象，表示当前audio context中所有节点的最终节点，一般表示音频渲染设备
        gainNode.connect(audioCtx.destination);
        // 指定音调的类型，其他还有square|triangle|sawtooth
        oscillator.type = 'sine';
        // 设置当前播放声音的频率，也就是最终播放声音的调调
        oscillator.frequency.value = frequency;
        // 当前时间设置音量为0
        gainNode.gain.setValueAtTime(0, audioCtx.currentTime);
        // 0.01秒后音量为1
        gainNode.gain.linearRampToValueAtTime(1, audioCtx.currentTime + 0.01);
        // 音调从当前时间开始播放
        oscillator.start(audioCtx.currentTime);
        // 1秒内声音慢慢降低，是个不错的停止声音的方法
        gainNode.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 1);
        // 1秒后完全停止声音
        oscillator.stop(audioCtx.currentTime + 1);
      };
      play();
      timer = setTimeout(() => {
        emit('answer', answer.value);
      }, 2000);
    };
    onMounted(() => {
      init();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.matrix, (value, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(`box-item-${value ? 1 : 0} box-item`)
        }, _toDisplayString(value === 1 ? "*" : '·'), 3);
      }), 128))]), _createElementVNode("div", _hoisted_3, [!__props.reviewMode ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: _cache[0] || (_cache[0] = $event => onChoosed('Y'))
      }, {
        default: _withCtx(() => [_createTextVNode("发现目标")]),
        _: 1
      })) : _createCommentVNode("", true)])]);
    };
  }
};